export default "__VITE_ASSET__9074b36f__"